import { useEffect, useState, type ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { DetailPageLayout } from '@/components/Layout/DetailPageLayout';
import { Button, Card, Input } from '@/components/ui';

export default function InstitutionCreate() {
  const navigate = useNavigate();
  //todo: type및 add-lms-user-insert 브랜치가 rebase이후 rhf zod로 사용하여 수정할 예정
  const [state, setState] = useState<'NORMAL' | 'DELETED'>('NORMAL');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [selectedImageFile, setSelectedImageFile] = useState<File | null>(null);
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null);

  const handleImageFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);
    setSelectedImageFile(file);
    setImagePreviewUrl((prev) => {
      if (prev?.startsWith('blob:')) {
        URL.revokeObjectURL(prev);
      }
      return previewUrl;
    });
  };

  useEffect(() => {
    return () => {
      if (imagePreviewUrl?.startsWith('blob:')) {
        URL.revokeObjectURL(imagePreviewUrl);
      }
    };
  }, [imagePreviewUrl]);

  const handleCreate = () => {
    // TODO: API 연동 시 create mutation으로 교체
    alert('현재는 생성 폼 UI만 구현된 상태입니다. API 연동 후 등록 기능을 연결해주세요.');
  };

  return (
    <DetailPageLayout
      title="기관 등록"
      subtitle="새로운 기관 정보를 입력하세요."
      onBack={() => navigate('/dashboard/institutions')}
      actions={
        <Button variant="primary" onClick={handleCreate}>
          등록
        </Button>
      }
      secondaryActions={
        <Button variant="outline" onClick={() => navigate('/dashboard/institutions')}>
          취소
        </Button>
      }>
      <Card title="기본 정보">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Input label="기관 ID" value="" placeholder="등록 후 자동 생성됩니다." disabled />
          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">상태</label>
            <select
              value={state}
              onChange={(e) => setState(e.target.value as 'NORMAL' | 'DELETED')}
              className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm shadow-sm focus:border-blue-500 focus:ring-blue-500">
              <option value="NORMAL">NORMAL</option>
              <option value="DELETED">DELETED</option>
            </select>
          </div>
          <Input
            label="기관명"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="기관명을 입력하세요."
          />
          <Input
            label="기관 코드"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="기관 코드를 입력하세요."
          />
          <Input label="생성일" value="" placeholder="등록 시 자동 생성됩니다." disabled />
          <Input label="수정일" value="" placeholder="등록 시 자동 생성됩니다." disabled />
        </div>
      </Card>

      <Card title="기관 이미지">
        <div className="space-y-4">
          {imagePreviewUrl ? (
            <div className="flex items-center gap-6">
              <img
                src={imagePreviewUrl}
                alt="기관 이미지 미리보기"
                className="h-24 w-24 rounded-lg border border-slate-200 object-cover"
              />
              <div className="text-sm text-slate-600">
                <p className="font-medium text-slate-900">{selectedImageFile?.name}</p>
                <p>{selectedImageFile ? `${Math.round(selectedImageFile.size / 1024)} KB` : ''}</p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-slate-500">등록할 기관 이미지를 선택해주세요.</p>
          )}

          <div>
            <label className="mb-1 block text-sm font-medium text-slate-700">이미지 업로드</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageFileChange}
              className="block w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm file:mr-3 file:rounded-md file:border-0 file:bg-slate-100 file:px-3 file:py-1.5 file:text-sm file:font-medium hover:file:bg-slate-200"
            />
          </div>
        </div>
      </Card>
    </DetailPageLayout>
  );
}
